import Filter from "../components/filter/Filter";
import PostGrid from "../components/grid/PostGrid";
import Navbar from "../components/navbar/Navbar";

export default function Home() {
  return (
    <section className="wrapper">
      <Filter />
      <PostGrid />
    </section>
  );
}
